<template>
	<BaseCard
		:alt="alt"
		:class="{ 'outline-yellow outline-2 -outline-offset-2': selected }"
	>
		<ItemInner
			class="relative px-3 py-4"
			:price="price"
			:src="src"
			:collection="collection"
			:name="name"
			:preloader="preloader"
		>
			<BaseCheckbox :modelValue="selected" class="absolute top-3 left-3" />
		</ItemInner>
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import ItemInner from './ItemInner.vue'
import BaseCheckbox from './BaseCheckbox.vue'

defineProps<{
	alt?: boolean
	preloader?: string
	collection: string
	name: string
	src: string
	price: number
	selected?: boolean
}>()
</script>
